import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyAMkHAPZ_Ya7RWxe7AFYP3tlrFvWlO9BUg",
    authDomain: "react-redux-firebase-ec81c.firebaseapp.com",
    projectId: "react-redux-firebase-ec81c",
    storageBucket: "react-redux-firebase-ec81c.appspot.com",
    messagingSenderId: "535915439189",
    appId: "1:535915439189:web:ec158f07551f8f08b820dc"
};

const app = initializeApp(firebaseConfig);
export default app;